import React from "react";
import { Heart, Building2, PartyPopper } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Heart, Building2, PartyPopper];

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 lg:py-40 bg-[#F3EFE7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 lg:mb-20">
          <Reveal><Overline className="mb-6">{t.services.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-[#1A1A1A]">
              {t.services.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1A1A1A]/10 border border-[#1A1A1A]/10">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={i * 0.12} className="bg-[#F3EFE7]">
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full p-9 lg:p-12 flex flex-col gap-7 bg-[#F3EFE7] hover:bg-[#FAF9F6] transition-colors duration-500"
                >
                  <span className="inline-flex items-center justify-center w-14 h-14 border border-[#C5A880] text-[#B0926A] group-hover:bg-[#C5A880] group-hover:text-[#FAF9F6] transition-colors duration-500">
                    <Icon size={24} strokeWidth={1.5} />
                  </span>
                  <h3 className="font-display text-2xl sm:text-3xl font-medium text-[#1A1A1A]">{item.title}</h3>
                  <p className="text-[#4A4A4A] text-base font-light leading-relaxed">{item.desc}</p>
                  <span className="mt-auto pt-4 text-[11px] tracking-[0.25em] uppercase text-[#7A7A7A]">0{i + 1}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
